import { ServiceResponse } from '@sdbn/common';
import { CompleteTransportAssignment, TransportCompletionOption } from './../model/transport-completion-option';
import { TaskRelevance } from './../model/task-relevance.enum';
import { TaskAssignmentOptions } from './../model/task-assignment-options';
import { ResponseMessage } from '@sdbn/common';
import { TaskPosition } from './../model/task-position';
import { Identity } from '@sdbn/common';
import { TaskAssignmentDialogComponent } from './../component/task-assignment-dialog.component';
import { Task } from './../model/task';
import { AppServerAPI } from '@sdbn/common';
import { Injectable } from '@angular/core';
import { Observable, AsyncSubject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { HttpHeaders } from '@angular/common/http';
import { TaskCompletion } from '../model/task-completion';
import { DocumentTaskUpdate } from '../model/document-task-update';

@Injectable({
  providedIn: 'root'
})
export class TaskAssignmentService {

  constructor(
    private appServerAPI: AppServerAPI,
    private dialog: MatDialog
  ) { }

  public openAssignmentDialog(editTasks: Task[], processingStatusModel: string) {

    const subject = new AsyncSubject<Task[]>();

    this.loadTaskAssignmentOptions().subscribe(
      result => {

        // restore selection and options based on editableTasks
        for (const t of result.tasks) {
          if (editTasks != null) {
            const editableTask = editTasks.filter(et => et.id === t.id);
            if (editableTask.length === 1) {
              t.selected = true;

              for (const key of Object.keys(TaskRelevance)) {
                const rel = TaskRelevance[key];
                if (rel === editableTask[0].relevance) {
                  t.relevance = rel;
                }
              }

              t.processingStatus = editableTask[0].processingStatus;
            }
          }
        }

        this.dialog.open(TaskAssignmentDialogComponent, {
          data: { taskAssignmentOptions: result, processingStatusModel },
          panelClass: 'tmc-dialog-container'
        }).afterClosed().subscribe(
          dialogResult => {
            subject.next(dialogResult);
            subject.complete();
          }
        );
      }, error => {
        console.log('Error Loading tasks', error);
        subject.error(error);
      }
    );

    return subject;
  }

  public completeDocumentTask(transportId: number, taskId: number, type: string, name: string, content: any): AsyncSubject<void> {

    const subject = new AsyncSubject<void>();

    this.appServerAPI.postFile(`/client/control/tasks/complete-picture-task`, content, new HttpHeaders({
      'Content-Type': type,
      'Content-MD5': 'test', // TODO: Calculate MD5 hash of capture.blob
      transportId: transportId + '',
      taskId: taskId + '',
      filename: encodeURIComponent(name)
    })).toPromise().then(response => {
      subject.next();
      subject.complete();
    }, error => {
      console.log('completeDocumentTask call failed:', error);
      subject.error(error);
    });

    return subject;
  }

  private loadTaskAssignmentOptions(): Observable<TaskAssignmentOptions> {
    return this.appServerAPI.execute<TaskAssignmentOptions>('/client/control/tasks', {});
  }

  public loadPositionTasks(transport: Identity): Observable<TaskPosition[]> {
    return this.appServerAPI.execute<TaskPosition[]>('/client/control/tasks/positions', transport);
  }

  public completeTask(completion: TaskCompletion): Observable<ResponseMessage[]> {
    return this.appServerAPI.execute<ResponseMessage[]>('/client/control/tasks/complete-transport-task', completion);
  }

  public updateDocumentTask(completion: DocumentTaskUpdate): Observable<ResponseMessage[]> {
    return this.appServerAPI.execute<ResponseMessage[]>('/client/control/tasks/update-document-task', completion);
  }

  public getTransportCompletionOption(transport: Identity): Observable<TransportCompletionOption> {
    return this.appServerAPI.execute<TransportCompletionOption>('/client/control/tasks/completion-option', transport);
  }

  public completeTransportAssignment(completeTransportAssignment: CompleteTransportAssignment): Observable<ServiceResponse> {
    return this.appServerAPI.execute<ServiceResponse>('/client/control/tasks/complete-transport-assignment', completeTransportAssignment);
  }
}
